import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, message, Row, Col } from 'antd';
import { CrmSelectBox } from 'components/atoms'
import { fetcher } from 'services';
import { IMaskInput } from "react-imask";
import { makeMaskPhoneNumber } from "utils/form-utils"

export interface CrmMatchModalProps extends PopupProps {
    company_srl: number;
    company: string;
    crm_srl: number;
    name: string, 
    phone: string, 
    email: string, 
    phone2?: string, 
    position?: string
}

const CrmMatchModal = ({ isOpen, onClose, company_srl, company, crm_srl, name, phone, phone2, email, position }: CrmMatchModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [crmSrl, setCrmSrl] = useState<number>(crm_srl);
  const [crmName, setCrmName] = useState<string>(''); 
  const [crmInfo, setCrmInfo] = useState<CrmCodeListDto>(); 

  /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onSubmit = (e) => {
        onClose?.(true, crmSrl, crmName, e.crm_name, e.crm_phone, e.crm_email, e.crm_position, e.crm_phone2);        
    };
  
  /* ======================================================
   * effects
   * ====================================================== */
    useEffect(() => {
        form.setFieldsValue({
            crm_name: name, 
            crm_phone: makeMaskPhoneNumber(phone), 
            crm_email: email, 
            crm_position: position, 
            crm_phone2: phone2,
        });
        if (crm_srl > 0) {
            form.setFieldValue('crm_srl', crm_srl);
        }
    }, [])

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={530} title={'CRM 매칭'} closable>
            <Form
                form={form}
                name="RefCode"
                layout="horizontal"  
                labelCol={{ flex: '100px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item label={'고객사명'}>
                    <label>{company}</label>
                </Form.Item>   
                <Row>
                    <Col span={14}>
                        <Form.Item label={'담당자명'} name={'crm_name'}>
                            <Input type="text" placeholder=''/> 
                        </Form.Item>  
                    </Col>
                    <Col span={10}>
                        <Form.Item>   
                            <label>{crmInfo?.label}</label>                         
                        </Form.Item>  
                    </Col>
                </Row> 
                <Row>
                    <Col span={14}>
                        <Form.Item label={'핸드폰'} name={'crm_phone'}>
                            <Input onChange={(e) => form.setFieldValue('crm_phone', makeMaskPhoneNumber(e.target.value))} /> 
                        </Form.Item>    
                    </Col>
                    <Col span={10}>
                        <Form.Item>   
                            <label style={
                                (form.getFieldValue('crm_phone') && (form.getFieldValue('crm_phone').replaceAll('-', '')!==crmInfo?.phone?.replaceAll('-',''))) ? {color:'red'} : {}
                            }>{crmInfo?.phone?.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)}</label>  
                        </Form.Item>   
                    </Col>
                </Row> 
                <Row>
                    <Col span={14}>
                        <Form.Item label={'이메일'} name={'crm_email'}>
                            <Input type="text" placeholder=''/> 
                        </Form.Item> 
                    </Col>
                    <Col span={10}>
                        <Form.Item>   
                            <label style={
                                (form.getFieldValue('crm_email') && (form.getFieldValue('crm_email')!==crmInfo?.email) ? {color:'red'} : {})
                            }>{crmInfo?.email}</label>                         
                        </Form.Item>   
                    </Col>
                </Row> 
                <Row>
                    <Col span={14}>
                        <Form.Item label={'직급'} name={'crm_position'}>
                            <Input type="text" placeholder=''/> 
                        </Form.Item>     
                    </Col>
                    <Col span={10}>
                        <Form.Item>   
                            <label style={
                                (form.getFieldValue('crm_position') && (form.getFieldValue('crm_position')!==crmInfo?.position) ? {color:'red'} : {})
                            }>{crmInfo?.position}</label>                       
                        </Form.Item>  
                    </Col>
                </Row> 
                <Row>
                    <Col span={14}>
                        <Form.Item label={'유선전화'} name={'crm_phone2'}>
                            <Input  onChange={(e) => form.setFieldValue('crm_phone2', makeMaskPhoneNumber(e.target.value))} />
                        </Form.Item>     
                    </Col>
                    <Col span={10}>
                        <Form.Item>   
                            <label style={
                                (form.getFieldValue('crm_phone2') && (form.getFieldValue('crm_phone2').replaceAll('-', '')!==crmInfo?.tel?.replaceAll('-',''))) ? {color:'red'}: {}
                            }>{crmInfo?.tel?.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)}</label>  
                        </Form.Item> 
                    </Col>
                </Row>   
                <Form.Item name="crm_srl" label={'기존 담당자'} rules={[{ required: true, message: '' }]}>
                    <CrmSelectBox 
                        form={form} 
                        company={company_srl} 
                        company_name={company} 
                        required={true}
                        addCrm={{
                            id:0,
                            name: form.getFieldValue("crm_name"),
                            phone: form.getFieldValue('crm_phone'),
                            tel: form.getFieldValue('crm_phone2'),                            
                            email: form.getFieldValue('crm_email'),
                            position: form.getFieldValue('crm_position'),
                        }}  
                        onSelected={(value, option) => {setCrmSrl(Number(value)); setCrmName(option.label); setCrmInfo(option)}} />
                </Form.Item>                    
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary" disabled={!crmSrl}>매칭</Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(CrmMatchModal);    